import { useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useProduct } from '../../stores/product/product/ProductAction';
import { useProcessStep } from '../../stores/process/processStep/ProcessStepAction';
import { useProductBOM } from '../../stores/product/productBOM/ProductBOMAction';

export const useProductManagementData = (clickedRow) => {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session.data);
  const productApi = useProduct();
  const processApi = useProcessStep();
  const productBOMApi = useProductBOM();
  const currentPageRef = useRef(0);
  
  const searchProduct = useCallback((params) => {
    params.companySeq = session.companySeq
    dispatch(productApi.request.get(params));
  }, [dispatch, productApi.request]);

  const productCount = useCallback(() => {
    const params = {
      companySeq: session.companySeq
    }
    dispatch(productApi.request.getCount(params));

  }, [dispatch, productApi.request]);
  const addProduct = useCallback(async (params) => {
    params.companySeq = session?.companySeq;
    try {
      await productApi.request.post(params);
      alert('추가되었습니다');
      searchProduct({ companySeq: session?.companySeq, page: currentPageRef.current, size: 10 });
    } catch (error) {
      alert('실패했습니다');
    }
  }, [session?.companySeq, productApi.request, searchProduct]);

  const updateProduct = useCallback(async (params) => {
    params.companySeq = session?.companySeq;
    await productApi.request.put(params);
    searchProduct({ companySeq: session?.companySeq, page: currentPageRef.current, size: 10 });
  }, [session?.companySeq, productApi.request, searchProduct]);

  const deleteProduct = useCallback(async (row) => {
    const params = [row.productSeq];
    await productApi.request.delete(params);
    searchProduct({ companySeq: session?.companySeq, page: currentPageRef.current, size: 10 });
  }, [session?.companySeq, productApi.request, searchProduct]);

  const productPaging = useCallback((page) => {
    currentPageRef.current = page;
    const params = {
      companySeq: session?.companySeq,
      page: page,
      size: 10
    };
    searchProduct(params);
  }, [session?.companySeq, searchProduct]);

  const processStepPaging = useCallback((page) => {
    if(!clickedRow){
      return;
    }
    const params = {
      companySeq: session?.companySeq,
      productSeq: clickedRow.productSeq,
      page: page,
      size: 5
    };
    searchProcessStep(params);
  }, [session?.companySeq, searchProduct]);

  const productBOMPaging = useCallback((page) => {
    if(!clickedRow){
      return;
    }
    const params = {
      companySeq: session?.companySeq,
      productSeq: clickedRow.productSeq ,
      page: page,
      size: 5
    };
    searchProductBOM(params);
  }, [session?.companySeq, searchProduct]);

  const searchProcessStep = useCallback((params) => {
    params.size = 5
    dispatch(processApi.request.get(params));
  }, [dispatch, processApi.request]);

  const addProcessStep = useCallback(async (params) => {
    if (!clickedRow || !clickedRow.productSeq) {
      console.error("Cannot add process step: clickedRow or productSeq is missing.");
      alert('제품을 먼저 선택해주세요.');
      return;
    }
    params.companySeq = session?.companySeq;
    params.productSeq = clickedRow.productSeq;
    await processApi.request.post(params);
    searchProcessStep({ companySeq: session?.companySeq, productSeq: clickedRow.productSeq });
  }, [session?.companySeq, clickedRow?.productSeq, processApi.request, searchProcessStep]);

  const updateProcessStep = useCallback(async (params) => {
    if (!clickedRow || !clickedRow.productSeq) {
      console.error("Cannot update process step: clickedRow or productSeq is missing.");
      alert('제품을 먼저 선택해주세요.');
      return;
    }
    params.companySeq = session?.companySeq;
    params.productSeq = clickedRow.productSeq;
    await processApi.request.put(params);
    searchProcessStep({ companySeq: session?.companySeq, productSeq: clickedRow.productSeq });
  }, [session?.companySeq, clickedRow?.productSeq, processApi.request, searchProcessStep]);

  const deleteProcessStep = useCallback(async (row) => {
    if (!clickedRow || !clickedRow.productSeq) {
      console.error("Cannot delete process step: clickedRow or productSeq is missing.");
      alert('제품을 먼저 선택해주세요.');
      return;
    }
    const params = [row.processStepSeq];
    await processApi.request.delete(params);
    searchProcessStep({ companySeq: session?.companySeq, productSeq: clickedRow.productSeq });
  }, [session?.companySeq, clickedRow?.productSeq, processApi.request, searchProcessStep]);

  const searchProductBOM = useCallback((params) => {
    params.size = 5
    dispatch(productBOMApi.request.get(params));
  }, [dispatch, productBOMApi.request]);

  const addProductBOM = useCallback(async (params) => {
    if (!clickedRow || !clickedRow.productSeq) {
      console.error("Cannot add product BOM: clickedRow or productSeq is missing.");
      alert('제품을 먼저 선택해주세요.');
      return;
    }
    params.companySeq = session?.companySeq;
    params.productSeq = clickedRow.productSeq;
    await productBOMApi.request.post(params);
    searchProductBOM({ companySeq: session?.companySeq, productSeq: clickedRow.productSeq });
  }, [session?.companySeq, clickedRow?.productSeq, productBOMApi.request, searchProductBOM]);

  const updateProductBOM = useCallback(async (params) => {
    if (!clickedRow || !clickedRow.productSeq) {
      console.error("Cannot update product BOM: clickedRow or productSeq is missing.");
      alert('제품을 먼저 선택해주세요.');
      return;
    }
    params.companySeq = session?.companySeq;
    params.productSeq = clickedRow.productSeq;
    await productBOMApi.request.put(params);
    searchProductBOM({ companySeq: session?.companySeq, productSeq: clickedRow.productSeq });
  }, [session?.companySeq, clickedRow?.productSeq, productBOMApi.request, searchProductBOM]);

  const deleteProductBOM = useCallback(async (row) => {
    if (!clickedRow || !clickedRow.productSeq) {
      console.error("Cannot delete product BOM: clickedRow or productSeq is missing.");
      alert('제품을 먼저 선택해주세요.');
      return;
    }
    const params = [row.productBOMSeq];
    await productBOMApi.request.delete(params);
    searchProductBOM({ companySeq: session?.companySeq, productSeq: clickedRow.productSeq });
  }, [session?.companySeq, clickedRow?.productSeq, productBOMApi.request, searchProductBOM]);

  useEffect(() => {
    if (session?.companySeq) {
      searchProduct({ companySeq: session.companySeq });
    }
  }, [ session?.companySeq]);

  useEffect(() => {
    if (clickedRow?.productSeq && session?.companySeq) {
      const params = {
        companySeq: session.companySeq,
        productSeq: clickedRow.productSeq
      };
      searchProcessStep(params);
      searchProductBOM(params);
    }
  }, [clickedRow?.productSeq, session?.companySeq]);

  const refreshProduct = useCallback(() => {
    searchProduct({ companySeq: session?.companySeq, page: currentPageRef.current, size: 10 });
  }, [session?.companySeq, searchProduct]);

  return {
    searchProduct,
    refreshProduct,
    addProduct,
    updateProduct,
    deleteProduct,
    productPaging,
    searchProcessStep,
    addProcessStep,
    updateProcessStep,
    deleteProcessStep,
    processStepPaging,
    searchProductBOM,
    addProductBOM,
    updateProductBOM,
    deleteProductBOM,
    productBOMPaging
  };
};
